module.exports = __webpack_public_path__ + "img/times.31c107a4.svg";